import React from 'react'
import NetSparkerMappingForm from './NetSparkerMappingForm';
import NetSparkerCredentialsForm from './NetSparkerCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function NetSparkerConfigListing(props) {
    
    const extraColumns =  [
        {
            dataIndex: "websiteName",
            title: "Website",
            width: 175,
        },
        {
            dataIndex: "websiteUrl",
            title: 'Website Url',
            width: 175,
        }
    ];
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={NetSparkerMappingForm}
            CredentialsForm={NetSparkerCredentialsForm}
            extraColumns = {extraColumns}
        />
    )
}